
import {
    GET_FABRIC_STOCK_REQUEST,
    GET_FABRIC_STOCK_SUCCESS,
    GET_FABRIC_STOCK_ERROR,
} from "../actions/types";

export const fabricStockReport = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_FABRIC_STOCK_REQUEST:
      return {
        loading: true,
      };
    case GET_FABRIC_STOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_FABRIC_STOCK_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};